/**
 * http://confluence.mockuai.com/display/wdzgxcx/module_property%23title
 */
let config = [{
        key: "tips",
        value: "资讯链接可以拖拽改变顺序",
        type: "tips"
    },
    {
        name: "资讯",
        type: "module-name"
    },
    {
        key: "style_type",
        name: "样式",
        type: "radio-box-img",
        width: 84,
        "radio-list": [{
                url: "https://img.mockuai.com/tms/2018/1/9/upload_3deacdfb791f451bb19bdfd16d358457.png",
                value: 1
            },
            {
                url: "https://img.mockuai.com/tms/2018/1/9/upload_55ddbb47c9db08870a5b2c50f609f984.png",
                value: 2
            },
            {
                url: "https://img.mockuai.com/tms/2018/1/9/upload_d1570d0c4167250e18605d1786842854.png",
                value: 3
            }
        ]
    },
    {
        key: "link_data",
        name: "链接",
        type: "article-list"
    }
];

export default config;